import React from 'react';
import { Button } from '@material-ui/core';
import './LoaderButton.css';
import clsx from 'clsx';

export default function LoaderButton({ isLoading = false, text, loadingText = '', className = '', disabled = false, ...props }) {
  return (
    <Button variant='contained' color='primary' className={clsx(className, 'LoaderButton')} disabled={disabled || isLoading} {...props}>
      {!isLoading ? text : loadingText}
    </Button>
  );
}
